<template>
  <div class="tab-bar" role="tablist">
    <button
        v-for="tab in tabs"
        :key="tab.key"
        class="tab-bar-item"
        :class="{ active: modelValue === tab.key }"
        role="tab"
        :aria-selected="modelValue === tab.key"
        @click="$emit('update:modelValue', tab.key)"
    >
      <component v-if="tab.icon" :is="tab.icon" :size="16" class="tab-bar-icon"/>
      <span>{{ tab.label }}</span>
    </button>
  </div>
</template>

<script setup>
defineProps({
  tabs: {type: Array, required: true},
  modelValue: {type: String, required: true}
});

defineEmits(['update:modelValue']);
</script>

<style scoped>
.tab-bar {
  display: flex;
  position: relative;
  border-bottom: 1px solid var(--tblr-border-color);
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
}

.tab-bar::-webkit-scrollbar {
  display: none;
}

.tab-bar-item {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.25rem;
  padding: 0.625rem 0.5rem;
  font-size: 0.875rem;
  font-weight: 500;
  color: rgba(var(--tblr-body-color-rgb), 0.6);
  background: none;
  border: none;
  border-bottom: 2px solid transparent;
  margin-bottom: -1px;
  cursor: pointer;
  white-space: nowrap;
  transition: color 0.2s ease, border-color 0.2s ease;
}

.tab-bar-item.active {
  color: var(--tblr-primary);
  border-bottom-color: var(--tblr-primary);
}

.tab-bar-item:hover:not(.active) {
  color: rgba(var(--tblr-body-color-rgb), 0.8);
}

.tab-bar-icon {
  flex-shrink: 0;
}
</style>
